import {
  BaseHospitalService,
  Hospital,
  Region
} from '@ianesthesie-kit/services';

declare module '@ianesthesie-kit/services' {
  interface Hospital {
    country: 'US' | 'FR';
  }

  interface HospitalConfig {
    prescriptionEmail?: string; // TODO move this to kit as it is used in backoffice too
  }
}

export class HospitalService extends BaseHospitalService {
  private static readonly INSTANCE: HospitalService = new HospitalService();

  private constructor() {
    super('/bff/hospital');
  }

  public static getInstance() {
    return this.INSTANCE;
  }

  public static isUsapHospital(hospital?: Hospital): boolean {
    return hospital?.externalIdentifier?.toLowerCase() === 'usap';
  }

  protected transformResponseEntity(data: any): Hospital {
    const hosp = super.transformResponseEntity(data);
    hosp.country = hosp.addressDetails.region === Region.FRANCE ? 'FR' : 'US';
    return hosp;
  }
}
